// API Configuration for widget v2
export const API_CONFIG = {
    BASE_URL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:5002',
    AI_CHAT_URL: import.meta.env.VITE_AI_CHAT_URL || 'http://localhost:3001',
    ENDPOINTS: {
        AI_CHAT: '/api/ai-chat',
        SUBMIT_LEAD: '/api/submit-lead',
        ANALYTICS: '/api/chatbot/analytics',
        TEMPLATE_V2: '/api/chatbot/template/v2'
    }
};

export const API_BASE_URL = API_CONFIG.BASE_URL;

// AI chat backend URL (separate service)
export const getAIChatUrl = () => `${API_CONFIG.AI_CHAT_URL}/chat`;

// AI service inference endpoint
export const getInferServiceUrl = () => `${API_CONFIG.AI_CHAT_URL}/infer-service`;

// Helper functions for building full URLs
export const getApiUrl = (endpoint: string) => `${API_CONFIG.BASE_URL}${endpoint}`;

export const getChatApiUrl = () => getApiUrl(API_CONFIG.ENDPOINTS.AI_CHAT);

export const getSubmitLeadApiUrl = (botId: string) =>
    getApiUrl(`${API_CONFIG.ENDPOINTS.SUBMIT_LEAD}/${botId}`);

export const getSubmitLeadV2ApiUrl = (botId: string) =>
    getApiUrl(`${API_CONFIG.ENDPOINTS.SUBMIT_LEAD}/v2/${botId}`);

export const getAnalyticsApiUrl = () => getApiUrl(API_CONFIG.ENDPOINTS.ANALYTICS);

export const getTemplateApiUrl = (botId: string) =>
    getApiUrl(`${API_CONFIG.ENDPOINTS.TEMPLATE_V2}/bot/${botId}`);

export const getFeedbackApiUrl = () => getApiUrl('/api/feedback');

export const getSmilePhotoApiUrl = (botId: string) =>
    getApiUrl(`/api/chatbot/smile-photo/${encodeURIComponent(botId)}`);
